import { WM_STORAGE_KEYS } from '../../../constants/watermark'
import * as WM from '../typings'
export const setStorage = (newWM, groupId) => {
  let watermarks: WM.OriginWatermark[] = JSON.parse(localStorage.getItem(WM_STORAGE_KEYS.WM) || '[]')
  let groups = JSON.parse(localStorage.getItem(WM_STORAGE_KEYS.WM_GROUPS) || '{}')
  if (Array.isArray(watermarks)) {
    let index = watermarks.findIndex(
      (watermark: any) => watermark.id === newWM.id
    )
    if (index > -1) {
      watermarks[index] = newWM
    } else {
      watermarks.push(newWM)
    }
  } else {
    watermarks = [newWM]
  }
  if (groups) {
    if (groups[groupId]) {
      if (!groups[groupId].includes(newWM.id)) {
        groups[groupId] = [...groups[groupId], newWM.id]
      }
    } else {
      groups[groupId] = [newWM.id]
    }
  } else {
    groups[groupId] = [newWM.id]
  }
  localStorage.setItem(WM_STORAGE_KEYS.WM, JSON.stringify(watermarks))
  localStorage.setItem(WM_STORAGE_KEYS.WM_GROUPS, JSON.stringify(groups))
}

export const deleteStorage = (watermarkId, groupId) => {
  let watermarks = JSON.parse(localStorage.getItem(WM_STORAGE_KEYS.WM) || '[]')
  let groups = JSON.parse(localStorage.getItem(WM_STORAGE_KEYS.WM_GROUPS) || '{}')
  watermarks.splice(
    watermarks.findIndex((watermark) => watermark.id === watermarkId), 1
  )
  const watermarkIDs = groups[groupId].filter(id => id !== watermarkId)
  groups[groupId] = watermarkIDs
  localStorage.setItem(WM_STORAGE_KEYS.WM, JSON.stringify(watermarks))
  localStorage.setItem(WM_STORAGE_KEYS.WM_GROUPS, JSON.stringify(groups))
}
